import React from "react";
import { motion } from "framer-motion";
import { SectionLabel } from "./Shared";
import { PROCESS } from "../config/siteConfig";
import { stagger, fadeUp, viewportOnce } from "../lib/motion";

export const HowWeWork = () => (
  <section id="insights" className="bg-[#F7F7F5] py-24 md:py-36" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="max-w-3xl mb-16">
        <SectionLabel>How We Work</SectionLabel>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.03] tracking-tight text-[#111111]">
          A Clear, Considered Path to the <span className="text-[#C62828]">Right Hire.</span>
        </h2>
      </div>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="grid md:grid-cols-4 gap-10 md:gap-6 relative"
      >
        <div className="hidden md:block absolute top-[38px] left-0 right-0 h-px bg-[#111111]/10" />
        {PROCESS.map((p) => (
          <motion.div key={p.no} variants={fadeUp} className="relative" data-testid={`process-step-${p.no}`}>
            <div className="flex items-center gap-4 mb-6">
              <span className="relative z-10 bg-[#F7F7F5] pr-2 font-display text-5xl text-[#C62828] leading-none">
                {p.no}
              </span>
              <span className="hidden md:block flex-1 h-px" />
            </div>
            <h3 className="font-body font-600 text-xl text-[#111111] mb-3">{p.title}</h3>
            <p className="font-body text-[#555] text-sm leading-relaxed">{p.desc}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);

export default HowWeWork;
